import axios from 'axios'
import { handleSuccess, handleError } from './axiosHandler'
import { authHeader, authHeaderJson } from '../_helpers/auth-header'

import config from '../config'
const base_url = config.apiUrl

const model = 'Products/'

export const productsService = {
  getAll,
  getAllPaginate,
  getAllByCategoryType,
  getAllByCategoryAndBrand,
  getAllByBrandAndCategoryHelperType,
  getAllByCategoryTypeAndcategoryHelperTypeAndLoadGlobalIndexesForRelatedProducts,
  getProductQuantity,
  getAllByCategoryTypeAndBrand,
  getById,
  add,
  edit,
  delete: _delete,
  getImages,
  importFromExcel,
  ExportToCsv,

  AddProductAndRelatedProducts,
  EditProductAndRelatedProducts
}

function getAll() {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllPaginate(dto) {
  const url = base_url + model + 'getAllPaginate'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function getAllByCategoryType(categoryType) {
  const url = base_url + model + 'getAllByCategoryType/' + categoryType
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllByCategoryAndBrand(categoryId, brandId) {
  const url =
    base_url + model + 'getAllByCategoryAndBrand/' + categoryId + '/' + brandId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllByBrandAndCategoryHelperType(brandId, categoryHelperType) {
  const url =
    base_url + model + 'getAllByBrandAndCategoryHelperType/' + brandId + '/' + categoryHelperType
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllByCategoryTypeAndcategoryHelperTypeAndLoadGlobalIndexesForRelatedProducts(categoruType, categoryHelperType, index) {
  const url =
    base_url + model + 'getAllByCategoryTypeAndcategoryHelperTypeAndLoadGlobalIndexesForRelatedProducts/' + categoruType + '/' + categoryHelperType + '/' + index
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getProductQuantity(productId) {
  const url = base_url + model + 'getProductQuantity/' + productId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getAllByCategoryTypeAndBrand(categoryType, brandId) {
  const url =
    base_url +
    model +
    'getAllByCategoryTypeAndBrand/' +
    categoryType +
    '/' +
    brandId
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function getById(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function add(form) {
  const url = base_url + model
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, form, { headers: authHeaderJson() })
}

function edit(id, form) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, form, { headers: authHeaderJson() })
}

function _delete(id) {
  const url = base_url + model + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.delete(url, { headers: authHeader() })
}

function getImages(id) {
  const url = base_url + model + 'getImages/' + id
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.get(url, { headers: authHeader() })
}

function importFromExcel(dto) {
  const url = base_url + model + 'importFromExcel'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function ExportToCsv(dto) {
  const url = base_url + model + 'ExportToCsv'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function AddProductAndRelatedProducts(dto) {
  const url = base_url + model + 'AddProductAndRelatedProducts'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.post(url, dto, { headers: authHeaderJson() })
}

function EditProductAndRelatedProducts(dto) {
  const url = base_url + model + 'EditProductAndRelatedProducts'
  axios.interceptors.response.use(handleSuccess, handleError)
  return axios.put(url, dto, { headers: authHeaderJson() })
}
